module.exports = __webpack_public_path__ + "img/patent-icon.21eb4135.png";